// Auto-generated by scripts/build-translations.js
// DO NOT EDIT MANUALLY - run: node scripts/build-translations.js

export interface TranslationsManifest {
  [key: string]: {
    fr: string;
    en: string;
    es?: string;
    de?: string;
    it?: string;
    pt?: string;
    nl?: string;
  };
}

/**
 * Built-in translations manifest for offline-first experience.
 * Contains 649 translation keys with FR and EN fallbacks.
 *
 * These translations are bundled with the app and available immediately,
 * even before the app connects to Supabase.
 */
export const translationsManifest: TranslationsManifest = {
  "auth.account_created": {
    "fr": "Compte créé !",
    "en": "Account created!"
  },
  "auth.and_the": {
    "fr": "et la",
    "en": "and the"
  },
  "auth.back_to_login": {
    "fr": "Retour à la connexion",
    "en": "Back to login"
  },
  "auth.connecting": {
    "fr": "Connexion...",
    "en": "Connecting..."
  },
  "auth.continue_with_apple": {
    "fr": "Continuer avec Apple",
    "en": "Continue with Apple"
  },
  "auth.continue_with_facebook": {
    "fr": "Continuer avec Facebook",
    "en": "Continue with Facebook"
  },
  "auth.continue_with_google": {
    "fr": "Continuer avec Google",
    "en": "Continue with Google"
  },
  "auth.create_account": {
    "fr": "Créer un compte",
    "en": "Create account"
  },
  "auth.create_my_account": {
    "fr": "Créer mon compte",
    "en": "Create my account"
  },
  "auth.creating": {
    "fr": "Création...",
    "en": "Creating..."
  },
  "auth.forgot_password": {
    "fr": "Mot de passe oublié ?",
    "en": "Forgot password?"
  },
  "auth.i_accept_the": {
    "fr": "J'accepte les",
    "en": "I accept the"
  },
  "auth.i_want_to_receive_news_and_special_offer": {
    "fr": "Je souhaite recevoir les nouveautés et offres spéciales par email",
    "en": "I want to receive news and special offers by email"
  },
  "auth.log_in": {
    "fr": "Se connecter",
    "en": "Log in"
  },
  "auth.login": {
    "fr": "Connexion",
    "en": "Login"
  },
  "auth.minimum_6_characters": {
    "fr": "Minimum 6 caractères",
    "en": "Minimum 6 characters"
  },
  "auth.or_by_email": {
    "fr": "ou par email",
    "en": "or by email"
  },
  "auth.please_check_your_inbox_and_click_the_co": {
    "fr": "Veuillez vérifier votre boîte mail et cliquer sur le lien de confirmation.",
    "en": "Please check your inbox and click the confirmation link."
  },
  "auth.privacy_policy": {
    "fr": "politique de confidentialité",
    "en": "privacy policy"
  },
  "auth.reset": {
    "fr": "Réinitialiser",
    "en": "Reset"
  },
  "auth.reset_password": {
    "fr": "Réinitialiser le mot de passe",
    "en": "Reset password"
  },
  "auth.send_link": {
    "fr": "Envoyer le lien",
    "en": "Send link"
  },
  "auth.sending": {
    "fr": "Envoi en cours...",
    "en": "Sending..."
  },
  "auth.superhero123": {
    "fr": "SuperHero123",
    "en": "SuperHero123"
  },
  "auth.terms_of_service": {
    "fr": "conditions d'utilisation",
    "en": "terms of service"
  },
  "auth.text": {
    "fr": "••••••••",
    "en": "••••••••"
  },
  "auth.you_must_accept_the_terms_of_service_and": {
    "fr": "Vous devez accepter les conditions d'utilisation et la politique de confidentialité",
    "en": "You must accept the terms of service and privacy policy"
  },
  "auth.youremailcom": {
    "fr": "votre@email.com",
    "en": "your@email.com"
  },
  "books.all_adventures": {
    "fr": "Toutes les aventures",
    "en": "All adventures"
  },
  "books.all_books": {
    "fr": "Tous les livres",
    "en": "All books"
  },
  "books.back": {
    "fr": "Back",
    "en": "Back"
  },
  "books.books_of_the_week": {
    "fr": "Livres de la semaine",
    "en": "Books of the week"
  },
  "books.discover_our_free_stories": {
    "fr": "Découvrez nos histoires gratuites",
    "en": "Discover our free stories"
  },
  "books.enter_your_pin_code_to_access_subscripti": {
    "fr": "Entrez votre code PIN pour accéder aux abonnements",
    "en": "Enter your PIN code to access subscriptions"
  },
  "books.enter_your_pin_to_access_subscriptions": {
    "fr": "Enter your PIN to access subscriptions",
    "en": "Enter your PIN to access subscriptions"
  },
  "books.our_adventures": {
    "fr": "Nos Aventures",
    "en": "Our Adventures"
  },
  "books.parental_verification": {
    "fr": "Parental verification",
    "en": "Parental verification"
  },
  "books.preview": {
    "fr": "Aperçu",
    "en": "Preview"
  },
  "books.unlock_all": {
    "fr": "Débloquer tout",
    "en": "Unlock all"
  },
  "booksScreen.3_new_free_books_every_week_with_collect": {
    "fr": "3 nouveaux livres gratuits chaque semaine avec objets à collectionner !",
    "en": "3 new free books every week with collectible objects!"
  },
  "booksScreen.all_books": {
    "fr": "Tous les livres",
    "en": "All books"
  },
  "booksScreen.books_of_the_week": {
    "fr": "Livres de la semaine",
    "en": "Books of the week"
  },
  "booksScreen.enter_your_pin_to_access_subscriptions": {
    "fr": "Entrez votre code PIN pour accéder aux abonnements",
    "en": "Enter your PIN to access subscriptions"
  },
  "booksScreen.free_preview": {
    "fr": "Aperçu Gratuit",
    "en": "Free Preview"
  },
  "booksScreen.my_books": {
    "fr": "Mes Livres",
    "en": "My Books"
  },
  "booksScreen.objects_to_collect": {
    "fr": "Objets à collecter :",
    "en": "Objects to collect:"
  },
  "booksScreen.parental_verification": {
    "fr": "Vérification parentale",
    "en": "Parental verification"
  },
  "booksScreen.premium_subscription": {
    "fr": "Abonnement Premium",
    "en": "Premium Subscription"
  },
  "childProfile.all_their_progress_will_be_lost": {
    "fr": "Toute sa progression sera perdue.",
    "en": "All their progress will be lost."
  },
  "childProfile.allows_adapting_content_to_the_childs_ag": {
    "fr": "Permet d'adapter le contenu à l'âge de l'enfant",
    "en": "Allows adapting content to the child's age"
  },
  "childProfile.cancel": {
    "fr": "Annuler",
    "en": "Cancel"
  },
  "childProfile.childs_first_name": {
    "fr": "Prénom de l'enfant",
    "en": "Child's first name"
  },
  "childProfile.create_profile": {
    "fr": "Créer le profil",
    "en": "Create profile"
  },
  "childProfile.date_of_birth_optional": {
    "fr": "Date de naissance (optionnel)",
    "en": "Date of birth (optional)"
  },
  "childProfile.delete_this_profile": {
    "fr": "Supprimer ce profil",
    "en": "Delete this profile"
  },
  "childProfile.deleting": {
    "fr": "Suppression...",
    "en": "Deleting..."
  },
  "childProfile.edit_profile": {
    "fr": "Modifier le profil",
    "en": "Edit profile"
  },
  "childProfile.eg_emma": {
    "fr": "Ex: Emma",
    "en": "E.g.: Emma"
  },
  "childProfile.first_name_is_required": {
    "fr": "Le prénom est requis",
    "en": "First name is required"
  },
  "childProfile.first_name_must_be_at_least_2_characters": {
    "fr": "Le prénom doit contenir au moins 2 caractères",
    "en": "First name must be at least 2 characters"
  },
  "childProfile.new_player": {
    "fr": "Nouveau joueur",
    "en": "New player"
  },
  "childProfile.save": {
    "fr": "Enregistrer",
    "en": "Save"
  },
  "childProfile.saving": {
    "fr": "Enregistrement...",
    "en": "Saving..."
  },
  "childProfile.this_name_will_be_used_to_personalize_st": {
    "fr": "Ce prénom sera utilisé pour personnaliser les histoires",
    "en": "This name will be used to personalize stories"
  },
  "collection.add_to_decor": {
    "fr": "Ajouter au décor",
    "en": "Add to decor"
  },
  "collection.ajouter_au_decor": {
    "fr": "Add to decoration",
    "en": "Add to decoration"
  },
  "collection.aucun_compagnon_disponible_pour_le_moment": {
    "fr": "No companions available yet",
    "en": "No companions available yet"
  },
  "collection.back": {
    "fr": "Back",
    "en": "Back"
  },
  "collection.books": {
    "fr": "livres",
    "en": "books"
  },
  "collection.collecte": {
    "fr": "Collected",
    "en": "Collected"
  },
  "collection.collected": {
    "fr": "Collecté",
    "en": "Collected"
  },
  "collection.companions": {
    "fr": "Compagnons",
    "en": "Companions"
  },
  "collection.companions_will_appear_here_when_you_unl": {
    "fr": "Les compagnons apparaîtront ici quand vous les débloquerez dans les histoires",
    "en": "Companions will appear here when you unlock them in stories"
  },
  "collection.debloque": {
    "fr": "Unlocked",
    "en": "Unlocked"
  },
  "collection.default_hero": {
    "fr": "Héros par défaut",
    "en": "Default hero"
  },
  "collection.erreur_de_chargement": {
    "fr": "Loading error",
    "en": "Loading error"
  },
  "collection.heroes": {
    "fr": "Héros",
    "en": "Heroes"
  },
  "collection.heros_par_defaut": {
    "fr": "Default hero",
    "en": "Default hero"
  },
  "collection.les_compagnons_apparaitront_ici_quand_vous_les_deb": {
    "fr": "Companions will appear here when you unlock them in stories",
    "en": "Companions will appear here when you unlock them in stories"
  },
  "collection.livres": {
    "fr": "books",
    "en": "books"
  },
  "collection.loading": {
    "fr": "Loading...",
    "en": "Loading..."
  },
  "collection.my_collection": {
    "fr": "My Collection",
    "en": "My Collection"
  },
  "collection.no_companions_available_at_the_moment": {
    "fr": "Aucun compagnon disponible pour le moment",
    "en": "No companions available at the moment"
  },
  "collection.objects": {
    "fr": "Objets",
    "en": "Objects"
  },
  "collection.selected": {
    "fr": "Sélectionné",
    "en": "Selected"
  },
  "collection.selectionne": {
    "fr": "Selected",
    "en": "Selected"
  },
  "collection.source_inconnue": {
    "fr": "Unknown source",
    "en": "Unknown source"
  },
  "collection.title": {
    "fr": "Ma Collection",
    "en": "My Collection"
  },
  "collection.unknown_source": {
    "fr": "Source inconnue",
    "en": "Unknown source"
  },
  "collection.unlocked": {
    "fr": "Débloqué",
    "en": "Unlocked"
  },
  "collectionScreen.add_to_background": {
    "fr": "Ajouter au fond",
    "en": "Add to background"
  },
  "collectionScreen.collect_all_objects_by_reading_books": {
    "fr": "Collecte tous les objets en lisant les livres !",
    "en": "Collect all objects by reading books!"
  },
  "collectionScreen.collected": {
    "fr": "Collecté",
    "en": "Collected"
  },
  "collectionScreen.collected_objects": {
    "fr": "Objets Collectés",
    "en": "Collected Objects"
  },
  "collectionScreen.companions_will_appear_here_when_you_unl": {
    "fr": "Les compagnons apparaîtront ici quand vous les débloquerez dans les histoires",
    "en": "Companions will appear here when you unlock them in stories"
  },
  "collectionScreen.default_hero": {
    "fr": "🎁 Héros par défaut",
    "en": "🎁 Default hero"
  },
  "collectionScreen.loading": {
    "fr": "Chargement...",
    "en": "Loading..."
  },
  "collectionScreen.loading_error": {
    "fr": "Erreur de chargement",
    "en": "Loading error"
  },
  "collectionScreen.my_collection": {
    "fr": "📚 Ma Collection",
    "en": "📚 My Collection"
  },
  "collectionScreen.no_companions_available_at_the_moment": {
    "fr": "Aucun compagnon disponible pour le moment",
    "en": "No companions available at the moment"
  },
  "collectionScreen.unknown_source": {
    "fr": "❓ Source inconnue",
    "en": "❓ Unknown source"
  },
  "collectionScreen.unlocked": {
    "fr": "🎁 Débloqué",
    "en": "🎁 Unlocked"
  },
  "common.back": {
    "fr": "Retour",
    "en": "Back"
  },
  "common.cancel": {
    "fr": "Annuler",
    "en": "Cancel"
  },
  "common.close": {
    "fr": "Fermer",
    "en": "Close"
  },
  "common.confirm": {
    "fr": "Confirmer",
    "en": "Confirm"
  },
  "common.delete": {
    "fr": "Supprimer",
    "en": "Delete"
  },
  "common.english_fallback": {
    "fr": "English fallback",
    "en": "English fallback"
  },
  "common.error": {
    "fr": "Erreur",
    "en": "Error"
  },
  "common.french_text": {
    "fr": "French text",
    "en": "French text"
  },
  "common.loading": {
    "fr": "Chargement...",
    "en": "Loading..."
  },
  "common.loading_error": {
    "fr": "Erreur de chargement",
    "en": "Loading error"
  },
  "common.retry": {
    "fr": "Réessayer",
    "en": "Retry"
  },
  "common.save": {
    "fr": "Enregistrer",
    "en": "Save"
  },
  "heroesScreen.book_required": {
    "fr": "Livre requis :",
    "en": "Book required:"
  },
  "heroesScreen.choose": {
    "fr": "Choisir",
    "en": "Choose"
  },
  "heroesScreen.choose_your_hero": {
    "fr": "Choisis ton héros",
    "en": "Choose your hero"
  },
  "heroesScreen.current_hero": {
    "fr": "Héros Actuel",
    "en": "Current Hero"
  },
  "heroesScreen.my_heroes": {
    "fr": "Mes Héros",
    "en": "My Heroes"
  },
  "heroesScreen.selected": {
    "fr": "Sélectionné",
    "en": "Selected"
  },
  "heroesScreen.unlock_new_heroes_by_reading_books": {
    "fr": "Débloque de nouveaux héros en lisant des livres !",
    "en": "Unlock new heroes by reading books!"
  },
  "home.books": {
    "fr": "Livres",
    "en": "Books"
  },
  "home.choose_your_hero_and_explore_fantastic_w": {
    "fr": "Choisis ton héros et explore des mondes fantastiques ! 🗺️",
    "en": "Choose your hero and explore fantastic worlds! 🗺️"
  },
  "home.choose_your_hero_and_explore_fantastic_worlds": {
    "fr": "Choose your hero and explore fantastic worlds! 🗺️",
    "en": "Choose your hero and explore fantastic worlds! 🗺️"
  },
  "home.collect_magical_objects_by_reading_stori": {
    "fr": "Collectionne des objets magiques en lisant des histoires ! 📚",
    "en": "Collect magical objects by reading stories! 📚"
  },
  "home.collect_magical_objects_by_reading_stories": {
    "fr": "Collect magical objects by reading stories! 📚",
    "en": "Collect magical objects by reading stories! 📚"
  },
  "home.collection": {
    "fr": "Collection",
    "en": "Collection"
  },
  "home.decorate_your_world_with_your_discovered": {
    "fr": "Décore ton monde avec tes trésors découverts ! ✨",
    "en": "Decorate your world with your discovered treasures! ✨"
  },
  "home.decorate_your_world_with_your_discovered_treasures": {
    "fr": "Decorate your world with your discovered treasures! ✨",
    "en": "Decorate your world with your discovered treasures! ✨"
  },
  "home.fusion": {
    "fr": "Fusion",
    "en": "Fusion"
  },
  "home.my_world": {
    "fr": "Mon Monde",
    "en": "My World"
  },
  "home.welcome_to_the_magical_adventure_of_lilhero": {
    "fr": "Welcome to the magical adventure of LilHero! 🌟",
    "en": "Welcome to the magical adventure of LilHero! 🌟"
  },
  "homeScreen.books": {
    "fr": "Livres",
    "en": "Books"
  },
  "homeScreen.choose_your_hero_and_explore_fantastic_w": {
    "fr": "Choisis ton héros et explore des mondes fantastiques ! 🗺️",
    "en": "Choose your hero and explore fantastic worlds! 🗺️"
  },
  "homeScreen.collect_magical_objects_by_reading_stori": {
    "fr": "Collectionne des objets magiques en lisant des histoires ! 📚",
    "en": "Collect magical objects by reading stories! 📚"
  },
  "homeScreen.collection": {
    "fr": "Collection",
    "en": "Collection"
  },
  "homeScreen.decorate_your_world_with_your_discovered": {
    "fr": "Décore ton monde avec tes trésors découverts ! ✨",
    "en": "Decorate your world with your discovered treasures! ✨"
  },
  "homeScreen.fusion": {
    "fr": "Fusion",
    "en": "Fusion"
  },
  "homeScreen.heroes": {
    "fr": "Héros",
    "en": "Heroes"
  },
  "homeScreen.my_world": {
    "fr": "Mon Monde",
    "en": "My World"
  },
  "homeScreen.settings": {
    "fr": "Paramètres",
    "en": "Settings"
  },
  "homeScreen.welcome_to_the_magical_adventure_of_lilh": {
    "fr": "Bienvenue dans l'aventure magique de LilHero ! 🌟",
    "en": "Welcome to the magical adventure of LilHero! 🌟"
  },
  "language.de": {
    "fr": "Allemand",
    "en": "German"
  },
  "language.en": {
    "fr": "Anglais",
    "en": "English"
  },
  "language.es": {
    "fr": "Espagnol",
    "en": "Spanish"
  },
  "language.fr": {
    "fr": "Français",
    "en": "French"
  },
  "language.it": {
    "fr": "Italien",
    "en": "Italian"
  },
  "language.nl": {
    "fr": "Néerlandais",
    "en": "Dutch"
  },
  "language.pt": {
    "fr": "Portugais",
    "en": "Portuguese"
  },
  "languageModal.choose_language": {
    "fr": "Choisir la langue",
    "en": "Choose language"
  },
  "modals.100_free_no_credit_card_required": {
    "fr": "100% gratuit • Aucune carte bancaire requise",
    "en": "100% free • No credit card required"
  },
  "modals.access_our_complete_library_of_premium_s": {
    "fr": "Accédez à l'intégralité de notre bibliothèque d'histoires premium",
    "en": "Access our complete library of premium stories"
  },
  "modals.access_your_collections_on_all_your_devi": {
    "fr": "🌍 Accédez à vos collections sur tous vos appareils",
    "en": "🌍 Access your collections on all your devices"
  },
  "modals.access_your_progress_heroes_and_collecti": {
    "fr": "Accédez à votre progression, vos héros et collections sur tous vos appareils",
    "en": "Access your progress, heroes and collections on all your devices"
  },
  "modals.all_books": {
    "fr": "Tous les livres",
    "en": "All books"
  },
  "modals.arrange_your_objects": {
    "fr": "🎨 Arrangez vos objets",
    "en": "🎨 Arrange your objects"
  },
  "modals.autorenewal_can_be_cancelled_at_any_time": {
    "fr": "Renouvellement automatique - Annulation possible à tout moment",
    "en": "Auto-renewal - Can be cancelled at any time"
  },
  "modals.cancel_anytime": {
    "fr": "Annulation à tout moment",
    "en": "Cancel anytime"
  },
  "modals.collect_all_heroes_and_objects_without_l": {
    "fr": "Collectionnez tous les héros et objets sans limite",
    "en": "Collect all heroes and objects without limit"
  },
  "modals.collect_unique_objects": {
    "fr": "📦 Collectez des objets uniques",
    "en": "📦 Collect unique objects"
  },
  "modals.create_a_free_account": {
    "fr": "Créer un compte gratuitement",
    "en": "Create a free account"
  },
  "modals.create_a_free_account_to_access_your_obj": {
    "fr": "Créez un compte gratuit pour accéder à votre collection d'objets et suivre votre progression.",
    "en": "Create a free account to access your object collection and track your progress."
  },
  "modals.create_a_free_account_to_customize_your": {
    "fr": "Créez un compte gratuit pour personnaliser votre monde avec vos objets collectés.",
    "en": "Create a free account to customize your world with your collected objects."
  },
  "modals.create_a_free_account_to_transform_your": {
    "fr": "Créez un compte gratuit pour transformer vos objets en versions brillantes et spéciales.",
    "en": "Create a free account to transform your objects into shiny and special versions."
  },
  "modals.create_a_free_account_to_unlock_and_coll": {
    "fr": "Créez un compte gratuit pour débloquer et collecter des objets en lisant des histoires.",
    "en": "Create a free account to unlock and collect objects while reading stories."
  },
  "modals.create_a_free_account_to_unlock_and_cust": {
    "fr": "Créez un compte gratuit pour débloquer et personnaliser vos héros.",
    "en": "Create a free account to unlock and customize your heroes."
  },
  "modals.create_an_account_to_unlock_more_stories": {
    "fr": "Créez un compte pour débloquer plus d'histoires!",
    "en": "Create an account to unlock more stories!"
  },
  "modals.create_your_world": {
    "fr": "Créez votre monde !",
    "en": "Create your world!"
  },
  "modals.customize_your_avatar": {
    "fr": "🎭 Personnalisez votre avatar",
    "en": "🎭 Customize your avatar"
  },
  "modals.customize_your_home_screen": {
    "fr": "🏠 Personnalisez votre écran d'accueil",
    "en": "🏠 Customize your home screen"
  },
  "modals.customize_your_world": {
    "fr": "🎨 Personnalisez votre monde",
    "en": "🎨 Customize your world"
  },
  "modals.download_up_to_50_stories_to_read_withou": {
    "fr": "Téléchargez jusqu'à 50 histoires pour lire sans connexion",
    "en": "Download up to 50 stories to read without connection"
  },
  "modals.earn_rewards": {
    "fr": "Gagnez des récompenses !",
    "en": "Earn rewards!"
  },
  "modals.enjoy_a_complete_experience_without_limi": {
    "fr": "Profitez d'une expérience complète sans limites",
    "en": "Enjoy a complete experience without limits"
  },
  "modals.free_forever_no_credit_card_required": {
    "fr": "Gratuit pour toujours - Aucune carte bancaire requise",
    "en": "Free forever - No credit card required"
  },
  "modals.i_already_have_an_account": {
    "fr": "J'ai déjà un compte",
    "en": "I already have an account"
  },
  "modals.later": {
    "fr": "Plus tard",
    "en": "Later"
  },
  "modals.month": {
    "fr": "/mois",
    "en": "/month"
  },
  "modals.no_commitment": {
    "fr": "Sans engagement",
    "en": "No commitment"
  },
  "modals.offline_access": {
    "fr": "Accès hors ligne",
    "en": "Offline access"
  },
  "modals.premium_subscription": {
    "fr": "Abonnement Premium",
    "en": "Premium Subscription"
  },
  "modals.rare_objects": {
    "fr": "Objets rares",
    "en": "Rare objects"
  },
  "modals.save_your_choices": {
    "fr": "💾 Sauvegardez vos choix",
    "en": "💾 Save your choices"
  },
  "modals.save_your_collected_objects": {
    "fr": "💾 Sauvegardez vos objets collectés",
    "en": "💾 Save your collected objects"
  },
  "modals.save_your_progress": {
    "fr": "💾 Sauvegardez votre progression",
    "en": "💾 Save your progress"
  },
  "modals.save_your_transformations": {
    "fr": "💾 Sauvegardez vos transformations",
    "en": "💾 Save your transformations"
  },
  "modals.save_your_world": {
    "fr": "💾 Sauvegardez votre monde",
    "en": "💾 Save your world"
  },
  "modals.subscribe_now": {
    "fr": "S'abonner maintenant",
    "en": "Subscribe now"
  },
  "modals.track_your_progress": {
    "fr": "📊 Suivez votre progression",
    "en": "📊 Track your progress"
  },
  "modals.transform_your_objects": {
    "fr": "✨ Transformez vos objets",
    "en": "✨ Transform your objects"
  },
  "modals.transform_your_objects_into_shiny_and_sp": {
    "fr": "Transformez vos objets en versions brillantes et spéciales",
    "en": "Transform your objects into shiny and special versions"
  },
  "modals.unlimited_collection": {
    "fr": "Collection illimitée",
    "en": "Unlimited collection"
  },
  "modals.unlock_heroes": {
    "fr": "Débloquez des héros !",
    "en": "Unlock heroes!"
  },
  "modals.unlock_new_heroes": {
    "fr": "🦸 Débloquez de nouveaux héros",
    "en": "🦸 Unlock new heroes"
  },
  "modals.unlock_rare_versions": {
    "fr": "💎 Débloquez des versions rares",
    "en": "💎 Unlock rare versions"
  },
  "modals.upgrade_to_premium_to_unlock_all_feature": {
    "fr": "Passez Premium pour débloquer toutes les fonctionnalités!",
    "en": "Upgrade to Premium to unlock all features!"
  },
  "modals.your_collection_awaits": {
    "fr": "Votre collection vous attend !",
    "en": "Your collection awaits!"
  },
  "navigation.back": {
    "fr": "Retour",
    "en": "Back"
  },
  "navigation.home": {
    "fr": "Accueil",
    "en": "Home"
  },
  "navigation.settings": {
    "fr": "Paramètres",
    "en": "Settings"
  },
  "onboarding.choose_the_app_language": {
    "fr": "Choisissez la langue de l'application",
    "en": "Choose the app language"
  },
  "onboarding.create_a_4digit_parental_pin_to_protect": {
    "fr": "Créez un code PIN parental à 4 chiffres pour protéger les paramètres et les achats",
    "en": "Create a 4-digit parental PIN to protect settings and purchases"
  },
  "onboarding.secure_your_account": {
    "fr": "Sécurisez votre compte",
    "en": "Secure your account"
  },
  "onboarding.welcome": {
    "fr": "Bienvenue sur LilHero !",
    "en": "Welcome to LilHero!"
  },
  "parentalPin.account_password": {
    "fr": "Mot de passe du compte",
    "en": "Account password"
  },
  "parentalPin.choose_a_4digit_code": {
    "fr": "Choisissez un code à 4 chiffres",
    "en": "Choose a 4-digit code"
  },
  "parentalPin.choose_a_new_4digit_code": {
    "fr": "Choisissez un nouveau code à 4 chiffres",
    "en": "Choose a new 4-digit code"
  },
  "parentalPin.confirm_the_code": {
    "fr": "Confirmer le code",
    "en": "Confirm the code"
  },
  "parentalPin.confirm_the_new_code": {
    "fr": "Confirmer le nouveau code",
    "en": "Confirm the new code"
  },
  "parentalPin.create_a_pin_code": {
    "fr": "Créer un code PIN",
    "en": "Create a PIN code"
  },
  "parentalPin.enter_the_4digit_parental_pin": {
    "fr": "Entrez le code PIN parental à 4 chiffres",
    "en": "Enter the 4-digit parental PIN"
  },
  "parentalPin.enter_the_code_again_to_confirm": {
    "fr": "Entrez à nouveau le code pour confirmer",
    "en": "Enter the code again to confirm"
  },
  "parentalPin.enter_your_account_password_to_reset_the": {
    "fr": "Entrez le mot de passe de votre compte pour réinitialiser le PIN",
    "en": "Enter your account password to reset the PIN"
  },
  "parentalPin.forgot_pin": {
    "fr": "PIN oublié ?",
    "en": "Forgot PIN?"
  },
  "parentalPin.new_pin_code": {
    "fr": "Nouveau code PIN",
    "en": "New PIN code"
  },
  "parentalPin.parental_code": {
    "fr": "Code parental",
    "en": "Parental code"
  },
  "parentalPin.this_code_protects_access_to_settings_an": {
    "fr": "Ce code protège l'accès aux paramètres et achats",
    "en": "This code protects access to settings and purchases"
  },
  "parentalPin.verification": {
    "fr": "Vérification",
    "en": "Verification"
  },
  "parentalPin.verify": {
    "fr": "Vérifier",
    "en": "Verify"
  },
  "parentalPin.verifying": {
    "fr": "Vérification...",
    "en": "Verifying..."
  },
  "parentSettings.account": {
    "fr": "Compte",
    "en": "Account"
  },
  "parentSettings.activate": {
    "fr": "Activer",
    "en": "Activate"
  },
  "parentSettings.active": {
    "fr": "Actif",
    "en": "Active"
  },
  "parentSettings.active_subscription": {
    "fr": "Abonnement actif",
    "en": "Active subscription"
  },
  "parentSettings.active_subscription_detected": {
    "fr": "Abonnement actif détecté",
    "en": "Active subscription detected"
  },
  "parentSettings.add_a_profile": {
    "fr": "Ajouter un profil",
    "en": "Add a profile"
  },
  "parentSettings.bug": {
    "fr": "Bug",
    "en": "Bug"
  },
  "parentSettings.change": {
    "fr": "Modifier",
    "en": "Change"
  },
  "parentSettings.change_password": {
    "fr": "Changer le mot de passe",
    "en": "Change password"
  },
  "parentSettings.change_your_current_password": {
    "fr": "Modifier votre mot de passe actuel",
    "en": "Change your current password"
  },
  "parentSettings.changing": {
    "fr": "Modification...",
    "en": "Changing..."
  },
  "parentSettings.child_profiles": {
    "fr": "Profils enfants",
    "en": "Child profiles"
  },
  "parentSettings.choose_the_app_language": {
    "fr": "Choisir la langue de l'application",
    "en": "Choose the app language"
  },
  "parentSettings.confirm_password": {
    "fr": "Confirmer le mot de passe",
    "en": "Confirm password"
  },
  "parentSettings.connected_via": {
    "fr": "Connecté via",
    "en": "Connected via"
  },
  "parentSettings.contact_support": {
    "fr": "Contact & Support",
    "en": "Contact & Support"
  },
  "parentSettings.contact_us": {
    "fr": "Nous contacter",
    "en": "Contact us"
  },
  "parentSettings.delete": {
    "fr": "SUPPRIMER",
    "en": "DELETE"
  },
  "parentSettings.delete_account": {
    "fr": "Supprimer le compte",
    "en": "Delete account"
  },
  "parentSettings.deleting": {
    "fr": "Suppression...",
    "en": "Deleting..."
  },
  "parentSettings.deleting_your_account_does_not_cancel_yo": {
    "fr": "La suppression de votre compte n'annule pas votre abonnement. Vous continuerez à être facturé.",
    "en": "Deleting your account does not cancel your subscription. You will continue to be charged."
  },
  "parentSettings.describe_the_problem_encountered": {
    "fr": "Décrivez le problème rencontré...",
    "en": "Describe the problem encountered..."
  },
  "parentSettings.describe_the_problem_you_encountered": {
    "fr": "Décrivez le problème rencontré...",
    "en": "Describe the problem you encountered..."
  },
  "parentSettings.enable": {
    "fr": "Activer",
    "en": "Enable"
  },
  "parentSettings.free_trial": {
    "fr": "Essai gratuit",
    "en": "Free trial"
  },
  "parentSettings.google_play_menu_subscriptions_lilhero": {
    "fr": "Google Play → Menu → Abonnements → LilHero",
    "en": "Google Play → Menu → Subscriptions → LilHero"
  },
  "parentSettings.iphone_settings_your_name_subscriptions": {
    "fr": "Réglages iPhone → [votre nom] → Abonnements → LilHero",
    "en": "iPhone Settings → [your name] → Subscriptions → LilHero"
  },
  "parentSettings.language": {
    "fr": "Langue",
    "en": "Language"
  },
  "parentSettings.legal": {
    "fr": "Légal",
    "en": "Legal"
  },
  "parentSettings.lilhero_premium": {
    "fr": "LilHero Premium",
    "en": "LilHero Premium"
  },
  "parentSettings.limit_reached": {
    "fr": "Limite atteinte",
    "en": "Limit reached"
  },
  "parentSettings.log_out": {
    "fr": "Se déconnecter",
    "en": "Log out"
  },
  "parentSettings.log_out_of_parent_account": {
    "fr": "Déconnexion du compte parent",
    "en": "Log out of parent account"
  },
  "parentSettings.manage_your_subscription_in_your_store_s": {
    "fr": "Gérez votre abonnement dans les paramètres de votre store (App Store ou Google Play)",
    "en": "Manage your subscription in your store settings (App Store or Google Play)"
  },
  "parentSettings.maximum_3_profiles_per_account": {
    "fr": "Maximum 3 profils par compte",
    "en": "Maximum 3 profiles per account"
  },
  "parentSettings.message_sent_successfully_thank_you_for": {
    "fr": "Message envoyé avec succès ! Merci pour votre retour.",
    "en": "Message sent successfully! Thank you for your feedback."
  },
  "parentSettings.monthly": {
    "fr": "mensuel",
    "en": "monthly"
  },
  "parentSettings.motion_effects": {
    "fr": "Effets de mouvement",
    "en": "Motion effects"
  },
  "parentSettings.new_password": {
    "fr": "Nouveau mot de passe",
    "en": "New password"
  },
  "parentSettings.newsletter": {
    "fr": "Newsletter",
    "en": "Newsletter"
  },
  "parentSettings.not_configured_click_to_activate": {
    "fr": "Non configuré - Cliquez pour activer",
    "en": "Not configured - Click to activate"
  },
  "parentSettings.parallax_with_gyroscope": {
    "fr": "Parallaxe avec le gyroscope",
    "en": "Parallax with gyroscope"
  },
  "parentSettings.parental_control": {
    "fr": "Contrôle parental",
    "en": "Parental control"
  },
  "parentSettings.parental_pin": {
    "fr": "Code PIN parental",
    "en": "Parental PIN"
  },
  "parentSettings.password_changed_successfully": {
    "fr": "Mot de passe modifié avec succès !",
    "en": "Password changed successfully!"
  },
  "parentSettings.password_must_be_at_least_6_characters": {
    "fr": "Le mot de passe doit contenir au moins 6 caractères",
    "en": "Password must be at least 6 characters"
  },
  "parentSettings.passwords_dont_match": {
    "fr": "Les mots de passe ne correspondent pas",
    "en": "Passwords don't match"
  },
  "parentSettings.permanently_delete_your_account_and_data": {
    "fr": "Supprimer définitivement votre compte et vos données",
    "en": "Permanently delete your account and data"
  },
  "parentSettings.permission_denied": {
    "fr": "Permission refusée",
    "en": "Permission denied"
  },
  "parentSettings.permission_required": {
    "fr": "Permission requise",
    "en": "Permission required"
  },
  "parentSettings.pin_code_changed_successfully": {
    "fr": "Code PIN modifié avec succès !",
    "en": "PIN code changed successfully!"
  },
  "parentSettings.preferences": {
    "fr": "Préférences",
    "en": "Preferences"
  },
  "parentSettings.privacy_policy": {
    "fr": "Politique de confidentialité",
    "en": "Privacy policy"
  },
  "parentSettings.protects_access_to_settings": {
    "fr": "Protège l'accès aux paramètres",
    "en": "Protects access to settings"
  },
  "parentSettings.receive_news_and_offers": {
    "fr": "Recevoir les nouveautés et offres",
    "en": "Receive news and offers"
  },
  "parentSettings.send": {
    "fr": "Envoyer",
    "en": "Send"
  },
  "parentSettings.sending": {
    "fr": "Envoi...",
    "en": "Sending..."
  },
  "parentSettings.settings": {
    "fr": "Paramètres",
    "en": "Settings"
  },
  "parentSettings.share_your_idea_or_suggestion": {
    "fr": "Partagez votre idée ou suggestion...",
    "en": "Share your idea or suggestion..."
  },
  "parentSettings.subscription": {
    "fr": "Abonnement",
    "en": "Subscription"
  },
  "parentSettings.suggestion": {
    "fr": "Suggestion",
    "en": "Suggestion"
  },
  "parentSettings.suggestion_bug_or_question": {
    "fr": "Suggestion, bug ou question",
    "en": "Suggestion, bug or question"
  },
  "parentSettings.terms_of_service": {
    "fr": "Conditions d'utilisation",
    "en": "Terms of service"
  },
  "parentSettings.terms_of_use": {
    "fr": "Conditions d'utilisation",
    "en": "Terms of use"
  },
  "parentSettings.this_action_is_irreversible_all_your_dat": {
    "fr": "Cette action est irréversible. Toutes vos données seront supprimées :",
    "en": "This action is irreversible. All your data will be deleted:"
  },
  "parentSettings.to_cancel": {
    "fr": "Pour annuler :",
    "en": "To cancel:"
  },
  "parentSettings.trial": {
    "fr": "Essai",
    "en": "Trial"
  },
  "parentSettings.type_delete_to_confirm": {
    "fr": "Tapez SUPPRIMER pour confirmer :",
    "en": "Type DELETE to confirm:"
  },
  "parentSettings.unlimited_access_to_all_stories": {
    "fr": "Accès illimité à toutes les histoires",
    "en": "Unlimited access to all stories"
  },
  "parentSettings.upgrade_to_premium": {
    "fr": "Passer à Premium",
    "en": "Upgrade to Premium"
  },
  "parentSettings.yearly": {
    "fr": "annuel",
    "en": "yearly"
  },
  "parentSettings.your_collected_objects": {
    "fr": "Vos objets collectés",
    "en": "Your collected objects"
  },
  "parentSettings.your_customizations": {
    "fr": "Vos personnalisations",
    "en": "Your customizations"
  },
  "parentSettings.your_reading_progress": {
    "fr": "Votre progression de lecture",
    "en": "Your reading progress"
  },
  "paywall.exclusive_collectible_items": {
    "fr": "Objets exclusifs à collectionner",
    "en": "Exclusive collectible items"
  },
  "paywall.new_adventures_regularly": {
    "fr": "Nouvelles aventures régulièrement",
    "en": "New adventures regularly"
  },
  "paywall.no_purchases_to_restore": {
    "fr": "Aucun achat à restaurer",
    "en": "No purchases to restore"
  },
  "paywall.redirecting": {
    "fr": "Redirection en cours...",
    "en": "Redirecting..."
  },
  "paywall.restore_failed": {
    "fr": "Échec de la restauration",
    "en": "Restore failed"
  },
  "paywall.restore_my_purchases": {
    "fr": "Restaurer mes achats",
    "en": "Restore my purchases"
  },
  "paywall.restored": {
    "fr": "Abonnement restauré !",
    "en": "Subscription restored!"
  },
  "paywall.restoring": {
    "fr": "Restauration...",
    "en": "Restoring..."
  },
  "paywall.see_offers": {
    "fr": "Voir les offres",
    "en": "See offers"
  },
  "paywall.starting_from_417month": {
    "fr": "À partir de 4,17 €/mois",
    "en": "Starting from €4.17/month"
  },
  "paywall.unlimited_access_to_all_stories": {
    "fr": "Accès illimité à toutes les histoires",
    "en": "Unlimited access to all stories"
  },
  "paywall.what_awaits_you_with_premium": {
    "fr": "Ce qui vous attend avec Premium",
    "en": "What awaits you with Premium"
  },
  "paywall.your_trial_has_ended": {
    "fr": "Votre essai est terminé",
    "en": "Your trial has ended"
  },
  "paywall.your_trial_period_ended_a_few_days_ago": {
    "fr": "Votre période d'essai s'est terminée il y a quelques jours.",
    "en": "Your trial period ended a few days ago."
  },
  "paywall.your_trial_period_ended_yesterday": {
    "fr": "Votre période d'essai s'est terminée hier.",
    "en": "Your trial period ended yesterday."
  },
  "paywall.your_trial_period_just_ended": {
    "fr": "Votre période d'essai vient de se terminer.",
    "en": "Your trial period just ended."
  },
  "paywallScreen.exclusive_objects_to_collect": {
    "fr": "Objets exclusifs à collectionner",
    "en": "Exclusive objects to collect"
  },
  "paywallScreen.new_adventures_regularly": {
    "fr": "Nouvelles aventures régulièrement",
    "en": "New adventures regularly"
  },
  "paywallScreen.no_purchases_to_restore": {
    "fr": "Aucun achat à restaurer",
    "en": "No purchases to restore"
  },
  "paywallScreen.redirecting": {
    "fr": "Redirection en cours...",
    "en": "Redirecting..."
  },
  "paywallScreen.restore_my_purchases": {
    "fr": "Restaurer mes achats",
    "en": "Restore my purchases"
  },
  "paywallScreen.restoring": {
    "fr": "Restauration...",
    "en": "Restoring..."
  },
  "paywallScreen.see_offers": {
    "fr": "Voir les offres",
    "en": "See offers"
  },
  "paywallScreen.starting_at_417month": {
    "fr": "À partir de 4,17 €/mois",
    "en": "Starting at €4.17/month"
  },
  "paywallScreen.subscription_restored": {
    "fr": "Abonnement restauré !",
    "en": "Subscription restored!"
  },
  "paywallScreen.unlimited_access_to_all_stories": {
    "fr": "Accès illimité à toutes les histoires",
    "en": "Unlimited access to all stories"
  },
  "paywallScreen.what_awaits_you_with_premium": {
    "fr": "Ce qui vous attend avec Premium",
    "en": "What awaits you with Premium"
  },
  "paywallScreen.your_trial_has_ended": {
    "fr": "Votre essai est terminé",
    "en": "Your trial has ended"
  },
  "paywallScreen.your_trial_period_ended_yesterday": {
    "fr": "Votre période d'essai s'est terminée hier.",
    "en": "Your trial period ended yesterday."
  },
  "paywallScreen.your_trial_period_just_ended": {
    "fr": "Votre période d'essai vient de se terminer.",
    "en": "Your trial period just ended."
  },
  "pin.a_reset_email_has_been_sent": {
    "fr": "Un email de réinitialisation a été envoyé",
    "en": "A reset email has been sent"
  },
  "pin.account_password": {
    "fr": "Mot de passe du compte",
    "en": "Account password"
  },
  "pin.choose_a_4digit_code": {
    "fr": "Choisissez un code à 4 chiffres",
    "en": "Choose a 4-digit code"
  },
  "pin.choose_a_new_4digit_code": {
    "fr": "Choisissez un nouveau code à 4 chiffres",
    "en": "Choose a new 4-digit code"
  },
  "pin.codes_do_not_match": {
    "fr": "Les codes ne correspondent pas",
    "en": "Codes do not match"
  },
  "pin.confirm_code": {
    "fr": "Confirmer le code",
    "en": "Confirm code"
  },
  "pin.confirm_new_code": {
    "fr": "Confirmer le nouveau code",
    "en": "Confirm new code"
  },
  "pin.continue_with": {
    "fr": "Continuer avec",
    "en": "Continue with"
  },
  "pin.create_a_pin_code": {
    "fr": "Créer un code PIN",
    "en": "Create a PIN code"
  },
  "pin.enter_code_again_to_confirm": {
    "fr": "Entrez à nouveau le code pour confirmer",
    "en": "Enter code again to confirm"
  },
  "pin.enter_the_4digit_parental_pin_code": {
    "fr": "Entrez le code PIN parental à 4 chiffres",
    "en": "Enter the 4-digit parental PIN code"
  },
  "pin.enter_your_account_password_to_reset_the": {
    "fr": "Entrez le mot de passe de votre compte pour réinitialiser le PIN",
    "en": "Enter your account password to reset the PIN"
  },
  "pin.error_saving": {
    "fr": "Erreur lors de la sauvegarde",
    "en": "Error saving"
  },
  "pin.error_sending": {
    "fr": "Erreur lors de l'envoi",
    "en": "Error sending"
  },
  "pin.forgot": {
    "fr": "PIN oublié ?",
    "en": "Forgot PIN?"
  },
  "pin.forgot_password": {
    "fr": "Mot de passe oublié ?",
    "en": "Forgot password?"
  },
  "pin.incorrect_code": {
    "fr": "Code incorrect",
    "en": "Incorrect code"
  },
  "pin.incorrect_password": {
    "fr": "Mot de passe incorrect",
    "en": "Incorrect password"
  },
  "pin.new_pin_code": {
    "fr": "Nouveau code PIN",
    "en": "New PIN code"
  },
  "pin.parental_code": {
    "fr": "Code parental",
    "en": "Parental code"
  },
  "pin.reauthentication_error": {
    "fr": "Erreur de ré-authentification",
    "en": "Re-authentication error"
  },
  "pin.this_code_protects_access_to_settings_an": {
    "fr": "Ce code protège l'accès aux paramètres et achats",
    "en": "This code protects access to settings and purchases"
  },
  "pin.to_reset_your_pin_please_reconnect_with": {
    "fr": "Pour réinitialiser votre PIN, veuillez vous reconnecter avec votre compte",
    "en": "To reset your PIN, please reconnect with your account"
  },
  "pin.verification": {
    "fr": "Vérification",
    "en": "Verification"
  },
  "pin.verify": {
    "fr": "Vérifier",
    "en": "Verify"
  },
  "pin.verifying": {
    "fr": "Vérification...",
    "en": "Verifying..."
  },
  "pin.you_will_be_redirected_to_confirm_your_i": {
    "fr": "Vous serez redirigé pour confirmer votre identité",
    "en": "You will be redirected to confirm your identity"
  },
  "profile.add": {
    "fr": "Ajouter",
    "en": "Add"
  },
  "profile.all_progress_will_be_lost": {
    "fr": "Toute sa progression sera perdue.",
    "en": "All progress will be lost."
  },
  "profile.allows_adapting_content_to_the_childs_ag": {
    "fr": "Allows adapting content to the child's age",
    "en": "Allows adapting content to the child's age"
  },
  "profile.appuyez_sur_licone_engrenage_pour_les_pa": {
    "fr": "Appuyez sur l'icône engrenage pour les paramètres parentaux",
    "en": "Appuyez sur l'icône engrenage pour les paramètres parentaux"
  },
  "profile.cancel": {
    "fr": "Cancel",
    "en": "Cancel"
  },
  "profile.ce_prenom_sera_utilise_pour_personnaliser_les_hist": {
    "fr": "This name will be used to personalize stories",
    "en": "This name will be used to personalize stories"
  },
  "profile.childs_first_name": {
    "fr": "Child's first name",
    "en": "Child's first name"
  },
  "profile.create_a_profile": {
    "fr": "Créer un profil",
    "en": "Create a profile"
  },
  "profile.creer_le_profil": {
    "fr": "Create profile",
    "en": "Create profile"
  },
  "profile.date_de_naissance_optionnel": {
    "fr": "Date of birth (optional)",
    "en": "Date of birth (optional)"
  },
  "profile.date_of_birth_optional": {
    "fr": "Date de naissance (optionnel)",
    "en": "Date of birth (optional)"
  },
  "profile.delete": {
    "fr": "Supprimer",
    "en": "Delete"
  },
  "profile.delete_profile_of": {
    "fr": "Supprimer le profil de",
    "en": "Delete profile of"
  },
  "profile.delete_the_profile_of": {
    "fr": "Delete the profile of",
    "en": "Delete the profile of"
  },
  "profile.delete_this_profile": {
    "fr": "Supprimer ce profil",
    "en": "Delete this profile"
  },
  "profile.deleting": {
    "fr": "Suppression...",
    "en": "Deleting..."
  },
  "profile.edit_profile": {
    "fr": "Modifier le profil",
    "en": "Edit profile"
  },
  "profile.enregistrement": {
    "fr": "Saving...",
    "en": "Saving..."
  },
  "profile.enregistrer": {
    "fr": "Save",
    "en": "Save"
  },
  "profile.erreur_lors_de_la_sauvegarde": {
    "fr": "Error while saving",
    "en": "Error while saving"
  },
  "profile.erreur_lors_de_la_suppression": {
    "fr": "Error while deleting",
    "en": "Error while deleting"
  },
  "profile.error_deleting": {
    "fr": "Erreur lors de la suppression",
    "en": "Error deleting"
  },
  "profile.error_saving": {
    "fr": "Erreur lors de la sauvegarde",
    "en": "Error saving"
  },
  "profile.ex_emma": {
    "fr": "Ex: Emma",
    "en": "Ex: Emma"
  },
  "profile.first_name_is_required": {
    "fr": "Le prénom est requis",
    "en": "First name is required"
  },
  "profile.first_name_must_be_at_least_2_characters": {
    "fr": "Le prénom doit contenir au moins 2 caractères",
    "en": "First name must be at least 2 characters"
  },
  "profile.hello_name": {
    "fr": "Hello {name}",
    "en": "Hello {name}"
  },
  "profile.le_prenom_doit_contenir_au_moins_2_caracteres": {
    "fr": "First name must be at least 2 characters",
    "en": "First name must be at least 2 characters"
  },
  "profile.le_prenom_est_requis": {
    "fr": "First name is required",
    "en": "First name is required"
  },
  "profile.loading": {
    "fr": "Loading...",
    "en": "Loading..."
  },
  "profile.new_player": {
    "fr": "Nouveau joueur",
    "en": "New player"
  },
  "profile.no_child_profile_created": {
    "fr": "Aucun profil enfant créé",
    "en": "No child profile created"
  },
  "profile.nouveau_joueur": {
    "fr": "Nouveau joueur",
    "en": "New player"
  },
  "profile.qui_joue_aujourdhui": {
    "fr": "Qui joue aujourd'hui ?",
    "en": "Qui joue aujourd'hui ?"
  },
  "profile.save": {
    "fr": "Enregistrer",
    "en": "Save"
  },
  "profile.saving": {
    "fr": "Enregistrement...",
    "en": "Saving..."
  },
  "profile.suppression": {
    "fr": "Suppression...",
    "en": "Deleting..."
  },
  "profile.supprimer_ce_profil": {
    "fr": "Supprimer ce profil",
    "en": "Delete this profile"
  },
  "profile.this_name_will_be_used_to_personalize_st": {
    "fr": "Ce prénom sera utilisé pour personnaliser les histoires",
    "en": "This name will be used to personalize stories"
  },
  "profile.years": {
    "fr": "years",
    "en": "years"
  },
  "profile.years_old": {
    "fr": "ans",
    "en": "years old"
  },
  "readingScreen.available_pages": {
    "fr": "Pages disponibles:",
    "en": "Available pages:"
  },
  "readingScreen.click_the_arrow_to_see_choices": {
    "fr": "Cliquez sur la flèche pour voir les choix →",
    "en": "Click the arrow to see choices →"
  },
  "readingScreen.end_of_the_story": {
    "fr": "Fin de l'histoire 🎉",
    "en": "End of the story 🎉"
  },
  "readingScreen.loading_story": {
    "fr": "Chargement de l'histoire...",
    "en": "Loading story..."
  },
  "readingScreen.page_not_found": {
    "fr": "Page introuvable:",
    "en": "Page not found:"
  },
  "readingScreen.reset_zoom": {
    "fr": "Réinitialiser le zoom",
    "en": "Reset zoom"
  },
  "readingScreen.rewards_unlocked": {
    "fr": "Récompenses débloquées !",
    "en": "Rewards unlocked!"
  },
  "readingScreen.the_end": {
    "fr": "Fin 🎉",
    "en": "The End 🎉"
  },
  "readingScreen.what_do_you_choose": {
    "fr": "Que choisis-tu ?",
    "en": "What do you choose?"
  },
  "rewardModal.continue": {
    "fr": "Continuer",
    "en": "Continue"
  },
  "rewardModal.find_your_objects_in_the_collection": {
    "fr": "💡 Retrouve tes objets dans la collection !",
    "en": "💡 Find your objects in the collection!"
  },
  "rewardModal.special": {
    "fr": "⭐ Spécial",
    "en": "⭐ Special"
  },
  "rewardModal.story_finished_no_rewards_for_this_story": {
    "fr": "Histoire terminée ! Aucune récompense pour cette histoire.",
    "en": "Story finished! No rewards for this story."
  },
  "rewardModal.you_already_read_this_story_rewards_are": {
    "fr": "Tu as déjà lu cette histoire ! Les récompenses ne sont données qu'à la première lecture.",
    "en": "You already read this story! Rewards are only given on the first reading."
  },
  "settings.abonnement_actif": {
    "fr": "Abonnement actif",
    "en": "Active subscription"
  },
  "settings.abonnement_actif_detecte": {
    "fr": "Active subscription detected",
    "en": "Active subscription detected"
  },
  "settings.actif": {
    "fr": "Actif",
    "en": "Active"
  },
  "settings.activer": {
    "fr": "Activer",
    "en": "Activate"
  },
  "settings.ajouter_un_profil": {
    "fr": "Ajouter un profil",
    "en": "Add a profile"
  },
  "settings.cancel": {
    "fr": "Cancel",
    "en": "Cancel"
  },
  "settings.cette_action_est_irreversible_toutes_vos_donnees_s": {
    "fr": "This action is irreversible. All your data will be deleted:",
    "en": "This action is irreversible. All your data will be deleted:"
  },
  "settings.changer_le_mot_de_passe": {
    "fr": "Changer le mot de passe",
    "en": "Change password"
  },
  "settings.choisissez_un_code_a_4_chiffres": {
    "fr": "Choose a 4-digit code",
    "en": "Choose a 4-digit code"
  },
  "settings.choisissez_un_nouveau_code_a_4_chiffres": {
    "fr": "Choose a new 4-digit code",
    "en": "Choose a new 4-digit code"
  },
  "settings.choose_the_app_language": {
    "fr": "Choose the app language",
    "en": "Choose the app language"
  },
  "settings.code_incorrect": {
    "fr": "Code incorrect",
    "en": "Incorrect code"
  },
  "settings.code_parental": {
    "fr": "Code parental",
    "en": "Parental code"
  },
  "settings.code_pin": {
    "fr": "Code PIN",
    "en": "Code PIN"
  },
  "settings.code_pin_modifie_avec_succes": {
    "fr": "PIN code changed successfully!",
    "en": "PIN code changed successfully!"
  },
  "settings.compte": {
    "fr": "Compte",
    "en": "Account"
  },
  "settings.confirm_password": {
    "fr": "Confirm password",
    "en": "Confirm password"
  },
  "settings.confirmer_le_code": {
    "fr": "Confirm code",
    "en": "Confirm code"
  },
  "settings.confirmer_le_nouveau_code": {
    "fr": "Confirmer le nouveau code",
    "en": "Confirm new code"
  },
  "settings.connecte_via": {
    "fr": "Connected via",
    "en": "Connected via"
  },
  "settings.contact_support": {
    "fr": "Contact & Support",
    "en": "Contact & Support"
  },
  "settings.continuer_avec": {
    "fr": "Continuer avec",
    "en": "Continue with"
  },
  "settings.controle_parental": {
    "fr": "Parental controls",
    "en": "Parental controls"
  },
  "settings.creer_un_code_pin": {
    "fr": "Create PIN code",
    "en": "Create PIN code"
  },
  "settings.deconnexion_du_compte_parent": {
    "fr": "Log out from parent account",
    "en": "Log out from parent account"
  },
  "settings.decrivez_le_probleme_rencontre": {
    "fr": "Describe the issue...",
    "en": "Describe the issue..."
  },
  "settings.delete": {
    "fr": "Delete",
    "en": "Delete"
  },
  "settings.edit": {
    "fr": "Edit",
    "en": "Edit"
  },
  "settings.effets_de_mouvement": {
    "fr": "Effets de mouvement",
    "en": "Motion effects"
  },
  "settings.entrez_a_nouveau_le_code_pour_confirmer": {
    "fr": "Enter code again to confirm",
    "en": "Enter code again to confirm"
  },
  "settings.entrez_le_code_pin_parental_a_4_chiffres": {
    "fr": "Enter the 4-digit parental PIN",
    "en": "Enter the 4-digit parental PIN"
  },
  "settings.entrez_le_mot_de_passe_de_votre_compte_pour_reinit": {
    "fr": "Enter your account password to reset the PIN",
    "en": "Enter your account password to reset the PIN"
  },
  "settings.envoi": {
    "fr": "Envoi...",
    "en": "Sending..."
  },
  "settings.envoyer": {
    "fr": "Envoyer",
    "en": "Send"
  },
  "settings.erreur_de_reauthentification": {
    "fr": "Re-authentication error",
    "en": "Re-authentication error"
  },
  "settings.erreur_de_verification": {
    "fr": "Verification error",
    "en": "Verification error"
  },
  "settings.erreur_lors_de_la_sauvegarde": {
    "fr": "Error while saving",
    "en": "Error while saving"
  },
  "settings.essai": {
    "fr": "Essai",
    "en": "Trial"
  },
  "settings.essai_gratuit": {
    "fr": "Essai gratuit",
    "en": "Free trial"
  },
  "settings.forgot_password": {
    "fr": "Forgot password?",
    "en": "Forgot password?"
  },
  "settings.forgot_pin": {
    "fr": "Forgot PIN?",
    "en": "Forgot PIN?"
  },
  "settings.gerez_votre_abonnement_dans_les_parametres_de_votr": {
    "fr": "Manage your subscription in your store settings",
    "en": "Manage your subscription in your store settings"
  },
  "settings.google_play_menu_abonnements_lilhero": {
    "fr": "Google Play → Menu → Abonnements → LilHero",
    "en": "Google Play → Menu → Subscriptions → LilHero"
  },
  "settings.la_suppression_de_votre_compte_nannule_p": {
    "fr": "La suppression de votre compte n'annule pas votre abonnement.",
    "en": "La suppression de votre compte n'annule pas votre abonnement."
  },
  "settings.language": {
    "fr": "Language",
    "en": "Language"
  },
  "settings.legal": {
    "fr": "Legal",
    "en": "Legal"
  },
  "settings.les_codes_ne_correspondent_pas": {
    "fr": "Les codes ne correspondent pas",
    "en": "Codes do not match"
  },
  "settings.limite_atteinte": {
    "fr": "Limite atteinte",
    "en": "Limit reached"
  },
  "settings.maximum_3_profils_par_compte": {
    "fr": "Maximum 3 profils par compte",
    "en": "Maximum 3 profiles per account"
  },
  "settings.message_envoye_avec_succes_merci_pour_votre_retour": {
    "fr": "Message sent successfully! Thanks for your feedback.",
    "en": "Message sent successfully! Thanks for your feedback."
  },
  "settings.modification": {
    "fr": "Modification...",
    "en": "Changing..."
  },
  "settings.modifier_votre_mot_de_passe_actuel": {
    "fr": "Modifier votre mot de passe actuel",
    "en": "Change your current password"
  },
  "settings.mot_de_passe_du_compte": {
    "fr": "Mot de passe du compte",
    "en": "Account password"
  },
  "settings.mot_de_passe_incorrect": {
    "fr": "Mot de passe incorrect",
    "en": "Incorrect password"
  },
  "settings.mot_de_passe_modifie_avec_succes": {
    "fr": "Password changed successfully!",
    "en": "Password changed successfully!"
  },
  "settings.newsletter": {
    "fr": "Newsletter",
    "en": "Newsletter"
  },
  "settings.non_configure_cliquez_pour_activer": {
    "fr": "Not configured - Click to enable",
    "en": "Not configured - Click to enable"
  },
  "settings.nous_contacter": {
    "fr": "Nous contacter",
    "en": "Contact us"
  },
  "settings.nouveau_code_pin": {
    "fr": "Nouveau code PIN",
    "en": "New PIN code"
  },
  "settings.nouveau_mot_de_passe": {
    "fr": "Nouveau mot de passe",
    "en": "New password"
  },
  "settings.parallaxe_avec_le_gyroscope": {
    "fr": "Parallaxe avec le gyroscope",
    "en": "Parallax with gyroscope"
  },
  "settings.parental_pin_code": {
    "fr": "Parental PIN code",
    "en": "Parental PIN code"
  },
  "settings.partagez_votre_idee_ou_suggestion": {
    "fr": "Share your idea or suggestion...",
    "en": "Share your idea or suggestion..."
  },
  "settings.passer_a_premium": {
    "fr": "Upgrade to Premium",
    "en": "Upgrade to Premium"
  },
  "settings.permission_refusee": {
    "fr": "Permission denied",
    "en": "Permission denied"
  },
  "settings.permission_requise": {
    "fr": "Permission requise",
    "en": "Permission required"
  },
  "settings.pour_annuler": {
    "fr": "Pour annuler :",
    "en": "To cancel:"
  },
  "settings.pour_reinitialiser_votre_pin_veuillez_vous_reconne": {
    "fr": "To reset your PIN, please reconnect with your account",
    "en": "To reset your PIN, please reconnect with your account"
  },
  "settings.preferences": {
    "fr": "Preferences",
    "en": "Preferences"
  },
  "settings.privacy_policy": {
    "fr": "Privacy policy",
    "en": "Privacy policy"
  },
  "settings.profils_enfants": {
    "fr": "Profils enfants",
    "en": "Child profiles"
  },
  "settings.protects_access_to_settings": {
    "fr": "Protects access to settings",
    "en": "Protects access to settings"
  },
  "settings.recevoir_les_nouveautes_et_offres": {
    "fr": "Receive news and offers",
    "en": "Receive news and offers"
  },
  "settings.reglages_iphone_votre_nom_abonnements_lilhero": {
    "fr": "iPhone Settings → [your name] → Subscriptions → LilHero",
    "en": "iPhone Settings → [your name] → Subscriptions → LilHero"
  },
  "settings.se_deconnecter": {
    "fr": "Log out",
    "en": "Log out"
  },
  "settings.settings": {
    "fr": "Settings",
    "en": "Settings"
  },
  "settings.subscription": {
    "fr": "Subscription",
    "en": "Subscription"
  },
  "settings.suggestion": {
    "fr": "Suggestion",
    "en": "Suggestion"
  },
  "settings.suggestion_bug_ou_question": {
    "fr": "Suggestion, bug ou question",
    "en": "Suggestion, bug or question"
  },
  "settings.suppression": {
    "fr": "Suppression...",
    "en": "Deleting..."
  },
  "settings.supprimer": {
    "fr": "SUPPRIMER",
    "en": "DELETE"
  },
  "settings.supprimer_definitivement_votre_compte_et_vos_donne": {
    "fr": "Permanently delete your account and data",
    "en": "Permanently delete your account and data"
  },
  "settings.supprimer_le_compte": {
    "fr": "Supprimer le compte",
    "en": "Delete account"
  },
  "settings.tapez_supprimer_pour_confirmer": {
    "fr": "Tapez SUPPRIMER pour confirmer :",
    "en": "Type DELETE to confirm:"
  },
  "settings.terms_of_use": {
    "fr": "Terms of use",
    "en": "Terms of use"
  },
  "settings.un_email_de_reinitialisation_a_ete_envoye": {
    "fr": "Reset email has been sent",
    "en": "Reset email has been sent"
  },
  "settings.unlimited_access_to_all_stories": {
    "fr": "Unlimited access to all stories",
    "en": "Unlimited access to all stories"
  },
  "settings.verification": {
    "fr": "Verification",
    "en": "Verification"
  },
  "settings.verifier": {
    "fr": "Verify",
    "en": "Verify"
  },
  "settings.vos_objets_collectes": {
    "fr": "Your collected objects",
    "en": "Your collected objects"
  },
  "settings.vos_personnalisations": {
    "fr": "Vos personnalisations",
    "en": "Your customizations"
  },
  "settings.votre_progression_de_lecture": {
    "fr": "Votre progression de lecture",
    "en": "Your reading progress"
  },
  "settings.vous_serez_redirige_pour_confirmer_votre_identite": {
    "fr": "You will be redirected to confirm your identity",
    "en": "You will be redirected to confirm your identity"
  },
  "subscription.a_partir_de_417_mois": {
    "fr": "À partir de 4,17 €/mois",
    "en": "Starting from €4.17/month"
  },
  "subscription.abonnement_premium": {
    "fr": "Abonnement Premium",
    "en": "Premium Subscription"
  },
  "subscription.abonnement_restaure": {
    "fr": "Subscription restored!",
    "en": "Subscription restored!"
  },
  "subscription.an": {
    "fr": "an",
    "en": "year"
  },
  "subscription.annual": {
    "fr": "Annual",
    "en": "Annual"
  },
  "subscription.aucun_achat_a_restaurer": {
    "fr": "No purchases to restore",
    "en": "No purchases to restore"
  },
  "subscription.aucune_offre_disponible_pour_le_moment": {
    "fr": "Aucune offre disponible pour le moment.",
    "en": "No offers available at this time."
  },
  "subscription.autonomous_reading_for_ages_58": {
    "fr": "Autonomous reading for ages 5-8",
    "en": "Autonomous reading for ages 5-8"
  },
  "subscription.autorenews_cancel_anytime": {
    "fr": "Renouvellement auto. Annulation possible à tout moment.",
    "en": "Auto-renews. Cancel anytime."
  },
  "subscription.back": {
    "fr": "Back",
    "en": "Back"
  },
  "subscription.bienvenue_dans_lilhero_premium": {
    "fr": "Bienvenue dans LilHero Premium !",
    "en": "Welcome to LilHero Premium!"
  },
  "subscription.ce_qui_vous_attend_avec_premium": {
    "fr": "Ce qui vous attend avec Premium",
    "en": "What awaits you with Premium"
  },
  "subscription.chargement_des_offres": {
    "fr": "Chargement des offres...",
    "en": "Loading offers..."
  },
  "subscription.daily_adventures": {
    "fr": "Des aventures quotidiennes",
    "en": "Daily adventures"
  },
  "subscription.des_aventures_quotidiennes": {
    "fr": "Des aventures quotidiennes",
    "en": "Daily adventures"
  },
  "subscription.des_univers_varies_pour_nourrir_son_imaginaire": {
    "fr": "Varied universes to nurture imagination",
    "en": "Varied universes to nurture imagination"
  },
  "subscription.echec_de_la_restauration": {
    "fr": "Échec de la restauration",
    "en": "Restore failed"
  },
  "subscription.echec_de_lachat": {
    "fr": "Échec de l'achat",
    "en": "Échec de l'achat"
  },
  "subscription.economisez_50": {
    "fr": "Économisez 50%",
    "en": "Save 50%"
  },
  "subscription.encouragez_la_lecture_active_pour_prepar": {
    "fr": "Encouragez la lecture active pour préparer la transition vers les romans non illustrés. Moins d'écran passif, de dessins animés, de lecture audio automatique : ici, l'enfant apprend à aimer la lecture en s'impliquant.",
    "en": "Encouragez la lecture active pour préparer la transition vers les romans non illustrés. Moins d'écran passif, de dessins animés, de lecture audio automatique : ici, l'enfant apprend à aimer la lecture en s'impliquant."
  },
  "subscription.enter_your_pin_to_confirm_the_purchase": {
    "fr": "Enter your PIN to confirm the purchase",
    "en": "Enter your PIN to confirm the purchase"
  },
  "subscription.grace_a_une_rotation_quotidienne_de_nos_aventures": {
    "fr": "With a daily rotation of our adventures, LilHero encourages a simple routine: 20 minutes of reading per day with regular exclusive content.",
    "en": "With a daily rotation of our adventures, LilHero encourages a simple routine: 20 minutes of reading per day with regular exclusive content."
  },
  "subscription.here_your_child_is_the_hero": {
    "fr": "Ici, votre enfant est le héros",
    "en": "Here, your child is the hero"
  },
  "subscription.ici_votre_enfant_est_le_heros": {
    "fr": "Ici, votre enfant est le héros",
    "en": "Here, your child is the hero"
  },
  "subscription.independent_reading_for_ages_5_to_8": {
    "fr": "Lecture autonome pour les 5 à 8 ans",
    "en": "Independent reading for ages 5 to 8"
  },
  "subscription.lilhero_propose_une_grande_diversite_de": {
    "fr": "LilHero propose une grande diversité de mondes pour stimuler la créativité de votre enfant, avec des personnages récurrents qu'il aura plaisir à retrouver d'une aventure à l'autre.",
    "en": "LilHero propose une grande diversité de mondes pour stimuler la créativité de votre enfant, avec des personnages récurrents qu'il aura plaisir à retrouver d'une aventure à l'autre."
  },
  "subscription.lire_pas_consommer": {
    "fr": "Lire, pas consommer",
    "en": "Read, don't consume"
  },
  "subscription.loading_offers": {
    "fr": "Chargement des offres...",
    "en": "Loading offers..."
  },
  "subscription.mois": {
    "fr": "mois",
    "en": "month"
  },
  "subscription.month": {
    "fr": "mois",
    "en": "month"
  },
  "subscription.monthly": {
    "fr": "Mensuel",
    "en": "Monthly"
  },
  "subscription.no_offers_available_at_this_time": {
    "fr": "Aucune offre disponible pour le moment.",
    "en": "No offers available at this time."
  },
  "subscription.nouvelles_aventures_regulierement": {
    "fr": "New adventures regularly",
    "en": "New adventures regularly"
  },
  "subscription.objets_exclusifs_a_collectionner": {
    "fr": "Exclusive objects to collect",
    "en": "Exclusive objects to collect"
  },
  "subscription.paiement_reussi": {
    "fr": "Payment successful!",
    "en": "Payment successful!"
  },
  "subscription.parental_verification": {
    "fr": "Vérification parentale",
    "en": "Parental verification"
  },
  "subscription.payment_successful": {
    "fr": "Paiement réussi !",
    "en": "Payment successful!"
  },
  "subscription.popular": {
    "fr": "Populaire",
    "en": "Popular"
  },
  "subscription.pour_vous_abonner_a_lilhero_premium_veuillez_utili": {
    "fr": "Pour vous abonner à LilHero Premium, veuillez utiliser notre application iOS ou Android. Votre abonnement sera automatiquement synchronisé sur tous vos appareils.",
    "en": "To subscribe to LilHero Premium, please use our iOS or Android app. Your subscription will be automatically synced across all your devices."
  },
  "subscription.premium_subscription": {
    "fr": "Abonnement Premium",
    "en": "Premium Subscription"
  },
  "subscription.processing": {
    "fr": "Traitement en cours...",
    "en": "Processing..."
  },
  "subscription.product_not_available": {
    "fr": "Produit non disponible",
    "en": "Product not available"
  },
  "subscription.produit_non_disponible": {
    "fr": "Produit non disponible",
    "en": "Product not available"
  },
  "subscription.read_dont_consume": {
    "fr": "Lire, pas consommer",
    "en": "Read, don't consume"
  },
  "subscription.redirection_en_cours": {
    "fr": "Redirection en cours...",
    "en": "Redirecting..."
  },
  "subscription.renouvellement_auto_annulation_possible_a_tout_mom": {
    "fr": "Renouvellement auto. Annulation possible à tout moment.",
    "en": "Auto-renews. Cancel anytime."
  },
  "subscription.restauration": {
    "fr": "Restauration...",
    "en": "Restoring..."
  },
  "subscription.restore_my_purchases": {
    "fr": "Restore my purchases",
    "en": "Restore my purchases"
  },
  "subscription.save_50": {
    "fr": "Économisez 50%",
    "en": "Save 50%"
  },
  "subscription.subscribe_from_the_mobile_app": {
    "fr": "Subscribe from the mobile app",
    "en": "Subscribe from the mobile app"
  },
  "subscription.thanks_to_a_daily_rotation_of_our_advent": {
    "fr": "Grâce à une rotation quotidienne de nos aventures, LilHero encourage une routine simple : 20 minutes de lecture par jour avec du contenu exclusif régulier.",
    "en": "Thanks to a daily rotation of our adventures, LilHero encourages a simple routine: 20 minutes of reading per day with regular exclusive content."
  },
  "subscription.to_subscribe_to_lilhero_premium_please_u": {
    "fr": "Pour vous abonner à LilHero Premium, veuillez utiliser notre application iOS ou Android. Votre abonnement sera automatiquement synchronisé sur tous vos appareils.",
    "en": "To subscribe to LilHero Premium, please use our iOS or Android app. Your subscription will be automatically synced across all your devices."
  },
  "subscription.traitement_en_cours": {
    "fr": "Traitement en cours...",
    "en": "Processing..."
  },
  "subscription.universe_customization": {
    "fr": "Universe customization",
    "en": "Universe customization"
  },
  "subscription.unlimited_access_to_all_stories": {
    "fr": "Unlimited access to all stories",
    "en": "Unlimited access to all stories"
  },
  "subscription.varied_universes_to_fuel_their_imaginati": {
    "fr": "Des univers variés pour nourrir son imaginaire",
    "en": "Varied universes to fuel their imagination"
  },
  "subscription.voir_les_offres": {
    "fr": "Voir les offres",
    "en": "See offers"
  },
  "subscription.votre_abonnement_est_maintenant_actif_profitez_de": {
    "fr": "Votre abonnement est maintenant actif. Profitez de toutes les histoires !",
    "en": "Your subscription is now active. Enjoy all the stories!"
  },
  "subscription.votre_enfant_pourra_batir_son_propre_monde_et_stim": {
    "fr": "Your child can build their own world and stimulate their creativity",
    "en": "Your child can build their own world and stimulate their creativity"
  },
  "subscription.votre_essai_est_termine": {
    "fr": "Your trial has ended",
    "en": "Your trial has ended"
  },
  "subscription.welcome_to_lilhero_premium": {
    "fr": "Bienvenue dans LilHero Premium !",
    "en": "Welcome to LilHero Premium!"
  },
  "subscription.year": {
    "fr": "an",
    "en": "year"
  },
  "subscription.yearly": {
    "fr": "Annuel",
    "en": "Yearly"
  },
  "subscription.your_child_can_build_their_own_world_and": {
    "fr": "Votre enfant pourra bâtir son propre monde et stimuler sa créativité",
    "en": "Your child can build their own world and stimulate their creativity"
  },
  "subscription.your_child_decides_multiple_choices_narr": {
    "fr": "Votre enfant décide : choix multiples, surprises narratives et mini-jeux pour rester captivé.",
    "en": "Your child decides: multiple choices, narrative surprises, and mini-games to stay engaged."
  },
  "subscription.your_child_decides_multiple_choices_narrative_surp": {
    "fr": "Your child decides: multiple choices, narrative surprises and mini-games to stay captivated.",
    "en": "Your child decides: multiple choices, narrative surprises and mini-games to stay captivated."
  },
  "subscription.your_subscription_is_now_active_enjoy_al": {
    "fr": "Votre abonnement est maintenant actif. Profitez de toutes les histoires !",
    "en": "Your subscription is now active. Enjoy all the stories!"
  },
  "subscriptionScreen.autorenewal_cancel_anytime": {
    "fr": "Renouvellement auto. Annulation possible à tout moment.",
    "en": "Auto-renewal. Cancel anytime."
  },
  "subscriptionScreen.daily_adventures": {
    "fr": "Des aventures quotidiennes",
    "en": "Daily adventures"
  },
  "subscriptionScreen.encourage_active_reading": {
    "fr": "Encouragez la lecture active...",
    "en": "Encourage active reading..."
  },
  "subscriptionScreen.enter_your_pin_to_confirm_the_purchase": {
    "fr": "Entrez votre code PIN pour confirmer l'achat",
    "en": "Enter your PIN to confirm the purchase"
  },
  "subscriptionScreen.here_your_child_is_the_hero": {
    "fr": "Ici, votre enfant est le héros",
    "en": "Here, your child is the hero"
  },
  "subscriptionScreen.independent_reading_for_ages_58": {
    "fr": "Lecture autonome pour les 5 à 8 ans",
    "en": "Independent reading for ages 5-8"
  },
  "subscriptionScreen.lilhero_offers_a_great_diversity": {
    "fr": "LilHero propose une grande diversité...",
    "en": "LilHero offers a great diversity..."
  },
  "subscriptionScreen.loading_offers": {
    "fr": "Chargement des offres...",
    "en": "Loading offers..."
  },
  "subscriptionScreen.monthly": {
    "fr": "Mensuel",
    "en": "Monthly"
  },
  "subscriptionScreen.no_offers_available_at_the_moment": {
    "fr": "Aucune offre disponible pour le moment.",
    "en": "No offers available at the moment."
  },
  "subscriptionScreen.parental_verification": {
    "fr": "Vérification parentale",
    "en": "Parental verification"
  },
  "subscriptionScreen.payment_successful": {
    "fr": "Paiement réussi !",
    "en": "Payment successful!"
  },
  "subscriptionScreen.popular": {
    "fr": "Populaire",
    "en": "Popular"
  },
  "subscriptionScreen.processing": {
    "fr": "Traitement en cours...",
    "en": "Processing..."
  },
  "subscriptionScreen.read_not_consume": {
    "fr": "Lire, pas consommer",
    "en": "Read, not consume"
  },
  "subscriptionScreen.subscribe_from_the_mobile_app": {
    "fr": "Abonnez-vous depuis l'application mobile",
    "en": "Subscribe from the mobile app"
  },
  "subscriptionScreen.subscribe_now": {
    "fr": "S'abonner maintenant",
    "en": "Subscribe now"
  },
  "subscriptionScreen.thanks_to_a_daily_rotation": {
    "fr": "Grâce à une rotation quotidienne...",
    "en": "Thanks to a daily rotation..."
  },
  "subscriptionScreen.to_subscribe_to_lilhero_premium_please_u": {
    "fr": "Pour vous abonner à LilHero Premium, veuillez utiliser notre application iOS ou Android...",
    "en": "To subscribe to LilHero Premium, please use our iOS or Android app..."
  },
  "subscriptionScreen.universe_customization": {
    "fr": "Personnalisation de l'univers",
    "en": "Universe customization"
  },
  "subscriptionScreen.varied_universes_to_feed_their_imaginati": {
    "fr": "Des univers variés pour nourrir son imaginaire",
    "en": "Varied universes to feed their imagination"
  },
  "subscriptionScreen.welcome_to_lilhero_premium": {
    "fr": "Bienvenue dans LilHero Premium !",
    "en": "Welcome to LilHero Premium!"
  },
  "subscriptionScreen.yearly": {
    "fr": "Annuel",
    "en": "Yearly"
  },
  "subscriptionScreen.your_child_can_build_their_own_world": {
    "fr": "Votre enfant pourra bâtir son propre monde...",
    "en": "Your child can build their own world..."
  },
  "subscriptionScreen.your_child_decides_multiple_choices_narr": {
    "fr": "Votre enfant décide: choix multiples, surprises narratives...",
    "en": "Your child decides: multiple choices, narrative surprises..."
  },
  "subscriptionScreen.your_subscription_is_now_active_enjoy_al": {
    "fr": "Votre abonnement est maintenant actif. Profitez de toutes les histoires !",
    "en": "Your subscription is now active. Enjoy all the stories!"
  },
  "transformation.aucun_objet_dans_la_collection": {
    "fr": "Aucun objet dans la collection",
    "en": "No objects in collection"
  },
  "transformation.aucun_objet_special": {
    "fr": "Aucun objet spécial",
    "en": "No special objects"
  },
  "transformation.back": {
    "fr": "Back",
    "en": "Back"
  },
  "transformation.erreur_instances_non_trouvees": {
    "fr": "Erreur: instances non trouvées",
    "en": "Error: instances not found"
  },
  "transformation.error_instances_not_found": {
    "fr": "Erreur: instances non trouvées",
    "en": "Error: instances not found"
  },
  "transformation.glissez_un_objet_normal_dans_le_premier_slot_puis": {
    "fr": "Glissez un objet normal dans le premier slot, puis un objet spécial dans le second slot pour créer une version scintillante !",
    "en": "Drag a normal object into the first slot, then a special object into the second slot to create a sparkling version!"
  },
  "transformation.instructions": {
    "fr": "Glissez un objet normal dans le premier slot, puis un objet spécial dans le second slot pour créer une version scintillante !",
    "en": "Drag a normal object into the first slot, then a special object into the second slot to create a sparkling version!"
  },
  "transformation.no_objects_in_collection": {
    "fr": "Aucun objet dans la collection",
    "en": "No objects in collection"
  },
  "transformation.no_special_objects": {
    "fr": "Aucun objet spécial",
    "en": "No special objects"
  },
  "transformation.normal_objects": {
    "fr": "Objets Normaux",
    "en": "Normal Objects"
  },
  "transformation.objets_normaux": {
    "fr": "Objets Normaux",
    "en": "Normal Objects"
  },
  "transformation.objets_speciaux": {
    "fr": "Objets Spéciaux",
    "en": "Special Objects"
  },
  "transformation.special_objects": {
    "fr": "Objets Spéciaux",
    "en": "Special Objects"
  },
  "transformation.title": {
    "fr": "Transformation",
    "en": "Transformation"
  },
  "transformation.transform": {
    "fr": "Transformer",
    "en": "Transform"
  },
  "transformation.transformation": {
    "fr": "Transformation",
    "en": "Transformation"
  },
  "transformation.transformer": {
    "fr": "Transformer",
    "en": "Transform"
  },
  "transformationScreen.drag_a_normal_object_to_the_first_slot_t": {
    "fr": "Glissez un objet normal dans le premier slot, puis un objet spécial (pierre brillante) dans le second slot...",
    "en": "Drag a normal object to the first slot, then a special object (shiny stone) to the second slot..."
  },
  "transformationScreen.error_instances_not_found": {
    "fr": "❌ Erreur: instances non trouvées",
    "en": "❌ Error: instances not found"
  },
  "transformationScreen.no_objects_in_the_collection": {
    "fr": "Aucun objet dans la collection",
    "en": "No objects in the collection"
  },
  "transformationScreen.no_special_objects": {
    "fr": "Aucun objet spécial",
    "en": "No special objects"
  },
  "transformationScreen.normal_objects": {
    "fr": "Objets Normaux",
    "en": "Normal Objects"
  },
  "transformationScreen.special_objects": {
    "fr": "Objets Spéciaux",
    "en": "Special Objects"
  },
  "transformationScreen.transform": {
    "fr": "Transformer ✨",
    "en": "Transform ✨"
  },
  "transformationScreen.transformation": {
    "fr": "Transformation",
    "en": "Transformation"
  },
  "trialBanner.last_trial_day": {
    "fr": "Dernier jour d'essai !",
    "en": "Last trial day!"
  },
  "trialBanner.subscribe": {
    "fr": "S'abonner",
    "en": "Subscribe"
  },
  "world.agrandir": {
    "fr": "Agrandir",
    "en": "Maximize"
  },
  "world.back": {
    "fr": "Back",
    "en": "Back"
  },
  "world.background": {
    "fr": "Fond",
    "en": "Background"
  },
  "world.companions": {
    "fr": "Compagnons",
    "en": "Companions"
  },
  "world.customize_your_world": {
    "fr": "Personnalisez votre monde !",
    "en": "Customize your world!"
  },
  "world.debloquez_des_compagnons_dans_les_histoires": {
    "fr": "Débloquez des compagnons dans les histoires !",
    "en": "Unlock companions in stories!"
  },
  "world.heroes": {
    "fr": "Heroes",
    "en": "Heroes"
  },
  "world.lisez_des_livres_pour_collectionner_des_objets": {
    "fr": "Lisez des livres pour collectionner des objets !",
    "en": "Read books to collect objects!"
  },
  "world.logo": {
    "fr": "Logo",
    "en": "Logo"
  },
  "world.maximize": {
    "fr": "Agrandir",
    "en": "Maximize"
  },
  "world.minimize": {
    "fr": "Réduire",
    "en": "Minimize"
  },
  "world.objects": {
    "fr": "Objects",
    "en": "Objects"
  },
  "world.personnalisez_votre_monde": {
    "fr": "Personnalisez votre monde !",
    "en": "Customize your world!"
  },
  "world.read_books_to_collect_objects": {
    "fr": "Lisez des livres pour collectionner des objets !",
    "en": "Read books to collect objects!"
  },
  "world.reduire": {
    "fr": "Réduire",
    "en": "Minimize"
  },
  "world.unlock_companions_in_stories": {
    "fr": "Débloquez des compagnons dans les histoires !",
    "en": "Unlock companions in stories!"
  },
  "worldScreen.auto": {
    "fr": "AUTO",
    "en": "AUTO"
  },
  "worldScreen.background": {
    "fr": "Fond",
    "en": "Background"
  },
  "worldScreen.collected_objects": {
    "fr": "Objets Collectés",
    "en": "Collected Objects"
  },
  "worldScreen.companions": {
    "fr": "Compagnons",
    "en": "Companions"
  },
  "worldScreen.customize_your_world": {
    "fr": "🛠️ Personnalisez votre monde !",
    "en": "🛠️ Customize your world!"
  },
  "worldScreen.drag_resize_and_rotate_your_objects": {
    "fr": "Glisse, redimensionne et fais pivoter tes objets",
    "en": "Drag, resize and rotate your objects"
  },
  "worldScreen.edit_mode": {
    "fr": "Mode Édition",
    "en": "Edit Mode"
  },
  "worldScreen.expand": {
    "fr": "Agrandir",
    "en": "Expand"
  },
  "worldScreen.heroes": {
    "fr": "Héros",
    "en": "Heroes"
  },
  "worldScreen.logo": {
    "fr": "Logo",
    "en": "Logo"
  },
  "worldScreen.minimize": {
    "fr": "Réduire",
    "en": "Minimize"
  },
  "worldScreen.objects": {
    "fr": "Objets",
    "en": "Objects"
  },
  "worldScreen.read_books_to_collect_objects": {
    "fr": "📚 Lisez des livres pour collectionner des objets !",
    "en": "📚 Read books to collect objects!"
  },
  "worldScreen.unlock_companions_in_the_stories": {
    "fr": "🐾 Débloquez des compagnons dans les histoires !",
    "en": "🐾 Unlock companions in the stories!"
  }
};

export default translationsManifest;
